import { Field, RadioGroup } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets//Core';
import { SampleMoisture } from 'Components/Worksheets/Shared/types';
import React from 'react';

let BsEnIsoLiquidLimitMoistureDeterminationSection: React.FC<IWithWorksheetInjectedProps> = ({
  createWorksheetSelector,
}) => {
  return (
    <ListFieldSection>
      <Field
        input={<RadioGroup />}
        name="WaterContentThroughPoints"
        options={[
          { label: 'Increasing', value: SampleMoisture.Increasing },
          { label: 'Decreasing', value: SampleMoisture.Decreasing },
        ]}
      />{' '}
    </ListFieldSection>
  );
};

BsEnIsoLiquidLimitMoistureDeterminationSection = withInjectedProps(BsEnIsoLiquidLimitMoistureDeterminationSection);

export { BsEnIsoLiquidLimitMoistureDeterminationSection };
export default BsEnIsoLiquidLimitMoistureDeterminationSection;
